module.exports = __webpack_public_path__ + "img/lg_ring_r_0_1_0@2x.b819fc7d.png";